module.exports = __webpack_public_path__ + "statics/img/done.0c210db1.png";